import * as React from 'react';

import { BaseComponent } from './BaseComponent';
import { HeaderButtonConfig, HeaderButtons } from './HeaderButtons';
import { UIHelper } from '../utils/UIHelper';
import { AppConfigurationStore } from '../stores/AppConfigurationStore';

import utils = egr.wcf.utils;

interface SidebarHeaderProps extends React.Props<SidebarHeader> {
    text: string;
    link?: string;
    linkClassName?: string;
    buttons?: Array<HeaderButtonConfig>;
    leftArrow?: boolean;
    className?: string;
    headerCallback?: () => void;
    arrowCallback?: () => void;
}

interface SidebarHeaderState {
}

export class SidebarHeader extends BaseComponent<SidebarHeaderProps, SidebarHeaderState> {
    protected element: HTMLElement;

    public componentDidMount(): void {
        this.element.addEventListener('touchmove', UIHelper.stopEvent, false);
    }

    public componentWillUnmount(): void {
        super.componentWillUnmount();
        this.element.removeEventListener('touchmove', UIHelper.stopEvent, false);
    }

    public render(): JSX.Element {
        if (AppConfigurationStore.getState().inApp) {
            const leftArrow: JSX.Element | null = this.leftArrow();
            return (
                <div
                    className={this.getCSSClass()}
                    onClick={this.headerClick}
                    ref={this.setElement}
                >
                    {this.getText()}
                    {leftArrow}
                    <HeaderButtons buttons={this.props.buttons}/>
                    {this.props.children}
                </div>
            );
        }

        return (
            <div
                className={this.getCSSClass()}
                onClick={this.headerClick}
                ref={this.setElement}
            >
                {this.getText()}
                <HeaderButtons buttons={this.props.buttons}/>
                {this.props.children}
            </div>
        );
    }

    protected setElement = (node: HTMLDivElement): void => {
        this.element = node;
    };

    protected getText = (): JSX.Element | null => {
        if (utils.string.isNullOrEmpty(this.props.text)) {
            return null;
        }
        if (AppConfigurationStore.getState().inApp) {
            return (
                <div className="sidebar-header-text">
                    <span>{this.props.text}</span>
                    {this.link()}
                </div>
            );
        }
        return (
            <div
                className={'sidebar-header-text' + (this.props.leftArrow ? ' sidebar-header-text-arrow' : '')}
            >
                <span>{this.props.text}</span>
                {this.link()}
            </div>
        );
    };

    protected leftArrowClick = (event: React.MouseEvent): void => {
        if (this.props.arrowCallback) {
            this.props.arrowCallback();
        }
    };

    protected headerClick = (event: React.MouseEvent): void => {
        if (this.props.headerCallback) {
            this.props.headerCallback();
        }
    };

    protected leftArrow = (): JSX.Element | null => {
        if (this.props.leftArrow || this.props.arrowCallback != null) {
            return (
                <div className="sidebar-left-arrow" onClick={this.leftArrowClick}/>
            );
        }
        return null;
    };

    protected link = (): JSX.Element | null => {
        if (this.props.link != null) {
            return (
                <a href={this.props.link} target="_blank" className={this.props.linkClassName ? this.props.linkClassName : 'questionmark-link'}/>
            );
        }
        return null;
    };

    protected getCSSClass = (): string => {
        if (!this.props.className) {
            return 'sidebar-header ' + (this.props.headerCallback ? ' sidebar-header-clickable' : '');
        }
        return ['sidebar-header', this.props.className].join(' ') + (this.props.headerCallback ? ' sidebar-header-clickable' : '');
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/SidebarHeader.tsx